module.exports = __webpack_public_path__ + "img/border_octagonal.8dc03119.svg";